import gql from 'graphql-tag';

export default gql`
mutation createPersonalizationSet($obj: insertPersonalizedVariableSetInput!) {
  insertPersonalizedVariableSet(object: $obj) {
    newPersonalizedVariableSetId
  }
}
`;
